import moment from 'moment';

// A calendar day with no time or zone, as the server's date-range filters take
// it: 'YYYY-MM-DD'. The server resolves it to day boundaries in the app zone,
// so the browser's zone never changes which readings, sessions or calls a
// range covers.
export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD';

// The zone the server resolves calendar days in, for every clinic.
const APP_TIME_ZONE = 'America/New_York';

// Today as the server sees it. Not the browser's day: for a Pacific user after
// 9 PM it is already tomorrow in the app zone. en-CA's numeric date format is
// 'YYYY-MM-DD', so no zone library is needed for this one value.
export function todayCalendarDate() {
    return new Date().toLocaleDateString('en-CA', { timeZone: APP_TIME_ZONE });
}

// a picker Date (local midnight) to its calendar day; null when empty
export function toCalendarDate(date) {
    if (!date) {
        return null;
    }
    const parsed = moment(date);
    return parsed.isValid() ? parsed.format(CALENDAR_DATE_FORMAT) : null;
}

// a calendar day to the local Date the pickers show it as. new Date('YYYY-MM-DD')
// would be UTC midnight, the previous evening anywhere in the US.
export function fromCalendarDate(calendarDate) {
    if (!calendarDate) {
        return null;
    }
    const parsed = moment(calendarDate, CALENDAR_DATE_FORMAT, true);
    return parsed.isValid() ? parsed.toDate() : null;
}
